import { IDrawerState } from '../store/drawer.slice';
import { useTypedSelector } from '../store/store';

export const useDrawer = <T = any>() => {
  const drawer = useTypedSelector(
    (state) => state.superAppDrawer,
  ) as IDrawerState<T>;
  return drawer;
};
